export enum DuplicateItemActions {
    KEEP = 1,
    DUPLICATE = 3,
    REPLACE = 2,
    REMOVE = 4
}
